// src/components/Admin/Finance/TableSales.js
import React, { useMemo, useState } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Chip } from '@mui/material';
import { Edit, Delete, Paid } from '@mui/icons-material';
import DateFormat from '../../../utils/DateFormat';
import { formatDate } from '../../../utils/formatDate';

export function TableSales({ sales = [], editSale, onDeleteSale, onViewPayments }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const pageRows = useMemo(
    () => sales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [sales, page, rowsPerPage]
  );

  const colorByStatus = (s) => {
    switch (s) {
      case 'paid': return 'success';
      case 'invoiced': return 'info';
      case 'open': return 'warning';
      case 'canceled': return 'error';
      default: return 'default';
    }
  };
  console.log(pageRows);
  
  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Cliente</TableCell>
              <TableCell>Servicio</TableCell>
              <TableCell>Subtotal</TableCell>
              <TableCell>IGV</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Pagado</TableCell>
              <TableCell>Pendiente</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Factura</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pageRows.map((row, idx) => (
              <TableRow key={row.id}>
                <TableCell>{page * rowsPerPage + idx + 1}</TableCell>
                <TableCell>{formatDate(row.issue_date)}</TableCell>
                <TableCell>{row.client?.name}</TableCell>
                <TableCell>{row.service_type}</TableCell>
                <TableCell>{row.amount_without_igv}</TableCell>
                <TableCell>{row.igv}</TableCell>
                <TableCell>{row.total}</TableCell>
                <TableCell>{row.paid_amount}</TableCell>
                <TableCell>{row.pending_amount}</TableCell>
                <TableCell>
                  <Chip size="small" label={row.status} color={colorByStatus(row.status)} />
                </TableCell>
                <TableCell>{row.invoiced ? `${row.invoice_series}-${row.invoice_number}` : '—'}</TableCell>
                <TableCell align="right">
                  <Button onClick={() => onViewPayments(row)} title="Pagos">
                    <Paid />
                  </Button>
                  <Button onClick={() => editSale(row)} title="Editar">
                    <Edit />
                  </Button>
                  <Button onClick={() => onDeleteSale(row)} title="Eliminar">
                    <Delete />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={sales.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
      />
    </>
  );
}
